import React from "react";
import { Typography } from "@mui/material";

export default function Error403() {
  return <Typography>403 Unauthorized Access</Typography>;
}
